import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  FormText,
  Card,
  Table,
} from "react-bootstrap";
import { API_ENDPOINTS, handleKeyDown, TERMS } from "../../constant/_constant";
import {
  IconFileDescription,
  IconLabel,
  IconArticle,
  IconUser,
  IconMail,
  IconPhone,
  IconTruck,
  IconFileText,
  IconReceipt,
  IconHomeSpark,
} from "@tabler/icons-react";
import { useFormContext, Controller } from "react-hook-form";

import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import usePostRequest from "../../hooks/usePostRequest";
import useDebounce from "../../hooks/useDebounce";

function PaymentAndShippingForm({ initialVal }) {
  const {
    control,
    watch,
    getValues,
    register,
    setValue,
    formState: { errors },
  } = useFormContext();

  const { debounceSearch } = useDebounce();
  const suppressAutoUpdate = useRef(false);
  const [searchDebounce, setSearchDebounce] = useState({
    searchName: "",
    searchEmail: "",
  });

  const [suggestion, setSuggestion] = useState([]);
  const OrderType = watch("ordertype");

  const {
    data: fetchdata,
    isLoading,
    postData: fetchUser,
  } = usePostRequest(API_ENDPOINTS.GET_CUSTOMER_AUTOFILL);

  const values = getValues();

  const prependCountryCodeIfMissing = (phoneNumber) => {
    if (!phoneNumber) return phoneNumber;
    const trimmed = phoneNumber.trim();
    if (trimmed.startsWith("+")) {
      return trimmed;
    }
    return "+1" + trimmed;
  };

  // console.log("values", values);

  const handleSelect = (item) => {
    suppressAutoUpdate.current = true;

    setValue("selectedBySuggestion", true);
    setValue("sameShipNameasKO", false);
    setValue("sameBillNameasKO", false);

    setValue(
      "contractOfficerName",
      `${item.first_name || ""} ${item.last_name || ""}`
    );
    setValue(
      "contractOfficerEmail",
      item?.primary_email ? item.primary_email.Address : ""
    );
    setValue(
      "contractOfficerPhone",
      prependCountryCodeIfMissing(item?.primary_phone?.FreeFormNumber || "")
    );
    // setValue(
    //   "contractOfficerPhone",
    //   item?.primary_phone ? item.primary_phone.FreeFormNumber : ""
    // );
    setValue("contractOfficerAddress", item.address);
    setValue("shippingCustomerName", item?.shipping_name);
    setValue("shippingCustomerEmail", item?.shipping_email);
    setValue(
      "shippingCustomerPhone",
      prependCountryCodeIfMissing(item?.shipping_phone || "")
    );
    // setValue("shippingCustomerPhone", item?.shipping_phone);

    if (item?.shipping_address) {
      const address = item.shipping_address;
      const formattedAddress = [
        address.Line1,
        address.Line2,
        `${address.City || ""}${address.City ? "," : ""} ${
          address.CountrySubDivisionCode || ""
        } ${address.PostalCode || ""}`.trim(),
        address.Country,
      ]
        .filter((line) => line && line.trim() !== "") // Remove blank lines
        .join("\n");

      setValue("shippingCustomerAddress", formattedAddress);
    }

    setValue("BillingCustomerName", item?.billing_name);
    setValue("BillingCustomerEmail", item?.billing_email);
    setValue(
      "BillingCustomerPhone",
      prependCountryCodeIfMissing(item?.billing_phone || "")
    );
    // setValue("BillingCustomerPhone", item?.billing_phone);

    if (item?.billing_address) {
      const address = item.billing_address;
      const formattedAddress = [
        address.Line1,
        address.Line2,
        `${address.City || ""}${address.City ? "," : ""} ${
          address.CountrySubDivisionCode || ""
        } ${address.PostalCode || ""}`.trim(),
        address.Country,
      ]
        .filter((line) => line && line.trim() !== "")
        .join("\n");
      setValue("BillingCustomerAddress", formattedAddress);
    }

    //     if (item?.shipping_address) {
    //       const address = JSON.parse(item.shipping_address);
    //       const formattedAddress = `${address.Line1 || ""}
    // ${address.Line2 || ""}
    // ${address.City || ""}, ${address.CountrySubDivisionCode || ""} ${address.PostalCode || ""
    //         }
    // ${address.Country || ""}`;
    //       setValue("shippingCustomerAddress", formattedAddress);
    //     }
    //     setValue("BillingCustomerName", item?.billing_name);
    //     setValue("BillingCustomerEmail", item?.billing_email);
    //     setValue("BillingCustomerPhone", item?.billing_phone);
    //     if (item?.billing_address) {
    //       const address = JSON.parse(item.billing_address);
    //       const formattedAddress = `${address.Line1 || ""}
    // ${address.Line2 || ""}
    // ${address.City || ""}, ${address.CountrySubDivisionCode || ""} ${address.PostalCode || ""
    //         }
    // ${address.Country || ""}`;
    //       setValue("BillingCustomerAddress", formattedAddress);
    //     }

    setSuggestion(null);
  };

  const handleSearchByName = (e) => {
    setValue("contractOfficerName", e.target.value);
    setSearchDebounce({ searchName: e.target.value });
  };

  const handleBlur = () => {
    setTimeout(() => {
      setSuggestion(null);
    }, 150);
  };

  const handleSearchByEmail = (e) => {
    setValue("contractOfficerEmail", e.target.value);
    setSearchDebounce({ searchEmail: e.target.value });
  };
  const onSuccessData = (data) => {
    setSuggestion(data);
  };

  const onErorrData = (data) => {
    setSuggestion(null);
  };

  useEffect(() => {
    if (
      searchDebounce?.searchEmail?.length > 0 ||
      searchDebounce?.searchName?.length > 0
    ) {
      fetchUser(
        {
          email:
            searchDebounce?.searchEmail?.length > 0
              ? searchDebounce?.searchEmail
              : undefined,
          first_name:
            searchDebounce?.searchName?.length > 0
              ? searchDebounce?.searchName
              : undefined,
          module_type: "ORDER",
        },
        onSuccessData,
        onErorrData
      );
    }
  }, [debounceSearch, searchDebounce]);

  const sameShipNameasKO = watch("sameShipNameasKO");
  const selectedBySuggestion = watch("selectedBySuggestion");
  const sameBillNameasKO = watch("sameBillNameasKO");
  const contractOfficerName = watch("contractOfficerName");
  const contractOfficerEmail = watch("contractOfficerEmail");
  const contractOfficerAddress = watch("contractOfficerAddress");
  const contractOfficerPhone = watch("contractOfficerPhone");

  const handleSameAsKO = (type, isChecked) => {
    const koFields = {
      name: getValues("contractOfficerName") || "",
      email: getValues("contractOfficerEmail") || "",
      phone: getValues("contractOfficerPhone") || "",
      address: getValues("contractOfficerAddress") || "",
    };

    if (type === "shipping") {
      // if (isChecked) {
      setValue("shippingCustomerName", koFields.name);
      setValue("shippingCustomerEmail", koFields.email);
      setValue("shippingCustomerPhone", koFields.phone);
      setValue("shippingCustomerAddress", koFields.address);
      // } else {
      //   setValue("shippingCustomerName", "");
      //   setValue("shippingCustomerEmail", "");
      //   setValue("shippingCustomerPhone", "");
      //   setValue("shippingCustomerAddress", "");
      // }
    } else if (type === "billing") {
      // if (isChecked) {
      setValue("BillingCustomerName", koFields.name);
      setValue("BillingCustomerEmail", koFields.email);
      setValue("BillingCustomerPhone", koFields.phone);
      setValue("BillingCustomerAddress", koFields.address);
      // } else {
      //   setValue("BillingCustomerName", "");
      //   setValue("BillingCustomerEmail", "");
      //   setValue("BillingCustomerPhone", "");
      //   setValue("BillingCustomerAddress", "");
      // }
    }
  };

  // useEffect(() => {
  //   const updateShippingDetails = () => {
  //     if (sameShipNameasKO === true) {
  //       setValue("shippingCustomerName", contractOfficerName);
  //       setValue("shippingCustomerAddress", contractOfficerAddress);
  //       setValue("shippingCustomerEmail", contractOfficerEmail);
  //       setValue("shippingCustomerPhone", contractOfficerPhone);
  //     } else if (initialVal === 0 && sameShipNameasKO === false) {
  //       console.log("else");
  //       setValue("shippingCustomerName", "");
  //       setValue("shippingCustomerAddress", "");
  //       setValue("shippingCustomerEmail", "");
  //       setValue("shippingCustomerPhone", "");
  //     }
  //   };
  //   updateShippingDetails();
  // }, [
  //   sameShipNameasKO,
  //   setValue,
  // ]);

  // useEffect(() => {
  //   const updateBillingDetails = () => {
  //     if (sameBillNameasKO === true) {
  //       setValue("BillingCustomerName", contractOfficerName);
  //       setValue("BillingCustomerAddress", contractOfficerAddress);
  //       setValue("BillingCustomerEmail", contractOfficerEmail);
  //       setValue("BillingCustomerPhone", contractOfficerPhone);
  //     } else if (initialVal === 0 && sameBillNameasKO === false) {
  //       console.log("else");
  //       setValue("BillingCustomerName", "");
  //       setValue("BillingCustomerAddress", "");
  //       setValue("BillingCustomerEmail", "");
  //       setValue("BillingCustomerPhone", "");
  //     }
  //   };
  //   updateBillingDetails();
  // }, [sameBillNameasKO, setValue]);

  const textareaRef = useRef(null);

  const address = watch("shippingCustomerAddress");
  const BillingAddress = watch("BillingCustomerAddress");

  const handleResize = (textarea) => {
    // console.log("textarea", textarea);
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  useEffect(() => {
    handleResize(textareaRef.current);
  }, [address]);

  useEffect(() => {
    handleResize(textareaRef.current);
  }, [BillingAddress]);

  useEffect(() => {
    if (OrderType == "CRK" || OrderType == "M" || OrderType == "S") {
      setValue("initial_consolidation", true);
    } else {
      setValue("initial_consolidation", false);
    }
  }, []);

  return (
    <>
      <Row className="mb-3">
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Estimated Delivery (Days)</Form.Label>
            <InputGroup>
              <Form.Control
                type="text"
                {...register("estimateddelivery")}
                defaultValue={30}
                onKeyDown={handleKeyDown}
              />
            </InputGroup>
            {errors.estimateddelivery && (
              <span className="text-danger">
                {errors.estimateddelivery.message}
              </span>
            )}
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Payment Terms</Form.Label>
            <InputGroup>
              <Form.Select {...register("payment_terms")}>
                {TERMS.Term.map((item, index) => (
                  <option key={index} value={item.Id}>
                    {item.Name}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
            {errors.payment_terms && (
              <span className="text-danger">
                {errors.payment_terms.message}
              </span>
            )}
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>FOB</Form.Label>
            <InputGroup>
              <Form.Select {...register("shipping_terms")}>
                <option value={""}>Select a terms</option>
                <option value={"FOB Origin"}>FOB Origin</option>
                <option value={"FOB Destination"}>FOB Destination</option>
              </Form.Select>
            </InputGroup>
            {errors.shipping_terms && (
              <span className="text-danger">
                {errors.shipping_terms.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Shipping Method Details</Form.Label>
            <InputGroup>
              <Form.Select {...register("shipping_method")}>
                <option value={""}>Select a method</option>
                <option value={"UPS"}>UPS</option>
                <option value={"FedEx"}>FedEx</option>
                <option value={"Freight"}>Freight</option>
                <option value={"Other"}>Other</option>
              </Form.Select>
            </InputGroup>
            {errors.shipping_method && (
              <span className="text-danger">
                {errors.shipping_method.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>

      {["10"].includes(watch("payment_terms")) && (
        <Col xs={12}>
          <Form.Group className="mb-3">
            <Form.Label>Payment Term Details</Form.Label>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder={`Enter payment term details`}
                {...register("payment_term_detail")}
              />
            </InputGroup>
            {errors.payment_term_detail && (
              <span className="text-danger">
                {errors.payment_term_detail.message}
              </span>
            )}
          </Form.Group>
        </Col>
      )}

      {["Freight", "Other"].includes(watch("shipping_method")) && (
        <Col xs={12}>
          <Form.Group className="mb-3">
            <Form.Label>
              {watch("shipping_method") === "Freight"
                ? "Shipping Method Freight Details"
                : "Shipping Method Other Details"}
            </Form.Label>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder={`Enter ${watch("shipping_method")} details`}
                {...register("shipping_method_detail")}
              />
            </InputGroup>
            {errors.shipping_method_detail && (
              <span className="text-danger">
                {errors.shipping_method_detail.message}
              </span>
            )}
          </Form.Group>
        </Col>
      )}

      <Card className="mb-3">
        <Card.Header className="card_header">
          <IconFileDescription /> KO (Contracting Officer) Details
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Full name</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconUser stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("contractOfficerName")}
                    onChange={handleSearchByName}
                    onBlur={handleBlur}
                    placeholder="Enter Full Name"
                  />
                </InputGroup>

                <div>
                  {((suggestion?.data?.length > 0 &&
                    searchDebounce?.searchName?.length > 0) ||
                    searchDebounce?.searchEmail?.length > 0) && (
                    <div className="suggestions_box">
                      <div className="table-responsive">
                        <Table>
                          <tbody>
                            {suggestion?.data?.map((item, index) => (
                              <tr
                                key={index}
                                onClick={() => handleSelect(item)}
                                style={{ cursor: "pointer" }}
                              >
                                <td>{item?.display_name}</td>
                                <td>{`${item?.first_name || ""} ${
                                  item?.last_name || ""
                                }`}</td>
                                <td>
                                  {item?.primary_email
                                    ? item.primary_email?.Address
                                    : null}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  )}
                </div>
                {errors.contractOfficerName && (
                  <span className="text-danger">
                    {errors.contractOfficerName.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>

                <InputGroup>
                  <InputGroup.Text>
                    <IconMail stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("contractOfficerEmail")}
                    onChange={handleSearchByEmail}
                    onBlur={handleBlur}
                    type="email"
                    placeholder="Enter Email"
                  />
                </InputGroup>
                {errors.contractOfficerEmail && (
                  <span className="text-danger">
                    {errors.contractOfficerEmail.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconPhone stroke={1} />
                  </InputGroup.Text>
                  <Controller
                    name="contractOfficerPhone"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      validate: (value) =>
                        (value && value.length > 0) || "Invalid phone number",
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        className="form-control"
                        {...field}
                        defaultCountry="US"
                        countryCallingCodeEditable={false}
                        international
                        placeholder="Enter phone number"
                        onChange={field.onChange}
                      />
                    )}
                  />
                </InputGroup>
                {errors.contractOfficerPhone && (
                  <span className="text-danger">
                    {errors.contractOfficerPhone.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconHomeSpark stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    as="textarea"
                    {...register("contractOfficerAddress")}
                    style={{
                      height: "auto",
                      minHeight: "80px",
                      resize: "none",
                    }}
                    onInput={(e) => {
                      e.target.style.height = "auto"; // Reset height to auto
                      e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight to expand
                    }}
                    placeholder="Enter Address"
                  />
                </InputGroup>
                {errors.contractOfficerAddress && (
                  <span className="text-danger">
                    {errors.contractOfficerAddress.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mb-3">
        <Card.Header className="card_header">
          <IconTruck /> Shipping Details
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Full name</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconUser stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("shippingCustomerName")}
                    type="text"
                    placeholder="Enter Full Name"
                  />
                </InputGroup>
                {errors.shippingCustomerName && (
                  <span className="text-danger">
                    {errors.shippingCustomerName.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconMail stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("shippingCustomerEmail")}
                    type="email"
                    placeholder="Enter  Email"
                  />
                </InputGroup>
                {errors.shippingCustomerEmail && (
                  <span className="text-danger">
                    {errors.shippingCustomerEmail.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconPhone stroke={1} />
                  </InputGroup.Text>
                  {/* Use Controller to integrate PhoneInput with react-hook-form */}
                  <Controller
                    name="shippingCustomerPhone"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      validate: (value) =>
                        (value && value.length > 0) || "Invalid phone number",
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        className="form-control"
                        {...field}
                        defaultCountry="US"
                        countryCallingCodeEditable={false}
                        international
                        placeholder="Enter phone number"
                        onChange={field.onChange}
                      />
                    )}
                  />
                </InputGroup>
                {errors.shippingCustomerPhone && (
                  <span className="text-danger">
                    {errors.shippingCustomerPhone.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconHomeSpark stroke={1} />
                  </InputGroup.Text>
                  <Controller
                    name="shippingCustomerAddress"
                    control={control}
                    defaultValue={address}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        as="textarea"
                        style={{
                          height: "auto",
                          minHeight: "80px",
                          resize: "none", // Prevent manual resize
                        }}
                        onInput={(e) => {
                          e.target.style.height = "auto"; // Reset height to auto
                          e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight to expand
                        }}
                        placeholder="Enter Address"
                      />
                    )}
                  />
                </InputGroup>
                {errors.shippingCustomerAddress && (
                  <span className="text-danger">
                    {errors.shippingCustomerAddress.message}
                  </span>
                )}

                <div className="d-flex gap-3 align-items-center">
                  <Form.Text className="ko_button d-flex gap-2 pt-2">
                    <Form.Check
                      className="ko_fill_link"
                      type="checkbox"
                      id="sameShipNameasKO"
                      label="Fill with KO’s information "
                      {...register("sameShipNameasKO", {
                        onChange: (e) =>
                          handleSameAsKO("shipping", e.target.checked),
                      })}
                    />
                  </Form.Text>

                  <Form.Text className="d-none">
                    <Form.Check
                      className="ko_fill_link"
                      type="checkbox"
                      id="selectedBySuggestion"
                      hidden
                      {...register("selectedBySuggestion")}
                    />
                  </Form.Text>
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mb-5">
        <Card.Header className="card_header">
          <IconReceipt /> Billing Details
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Full Name</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconUser stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("BillingCustomerName")}
                    placeholder="Enter Full Name"
                  />
                </InputGroup>
                {errors.BillingCustomerName && (
                  <span className="text-danger">
                    {errors.BillingCustomerName.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconMail stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("BillingCustomerEmail")}
                    type="email"
                    placeholder="Enter Email"
                  />
                </InputGroup>
                {errors.BillingCustomerEmail && (
                  <span className="text-danger">
                    {errors.BillingCustomerEmail.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconPhone stroke={1} />
                  </InputGroup.Text>

                  <Controller
                    name="BillingCustomerPhone"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      validate: (value) =>
                        (value && value.length > 0) || "Invalid phone number",
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        className="form-control"
                        {...field}
                        defaultCountry="US"
                        countryCallingCodeEditable={false}
                        international
                        placeholder="Enter phone number"
                        onChange={field.onChange}
                      />
                    )}
                  />
                </InputGroup>
                {errors.BillingCustomerPhone && (
                  <span className="text-danger">
                    {errors.BillingCustomerPhone.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconHomeSpark stroke={1} />
                  </InputGroup.Text>

                  <Controller
                    name="BillingCustomerAddress"
                    control={control}
                    defaultValue={BillingAddress}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        as="textarea"
                        ref={(e) => {
                          field.ref(e);
                          textareaRef.current = e;
                        }}
                        onInput={handleResize}
                        style={{ resize: "none" }}
                        placeholder="Enter Address"
                      />
                    )}
                  />
                </InputGroup>
                {errors.BillingCustomerAddress && (
                  <span className="text-danger">
                    {errors.BillingCustomerAddress.message}
                  </span>
                )}

                <Form.Text className="ko_button d-flex gap-2 pt-2">
                  <Form.Check
                    className="ko_fill_link"
                    type="checkbox"
                    id="sameBillNameasKO"
                    label="Fill with KO’s information"
                    {...register("sameBillNameasKO", {
                      onChange: (e) =>
                        handleSameAsKO("billing", e.target.checked),
                    })}
                  />
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
}

export default PaymentAndShippingForm;

// import React, { useEffect, useRef, useState } from "react";
// import {
//   Form,
//   Row,
//   Col,
//   InputGroup,
//   FormText,
//   Card,
//   Table,
// } from "react-bootstrap";
// import { API_ENDPOINTS, TERMS } from "../../constant/_constant";
// import {
//   IconFileDescription,
//   IconUser,
//   IconMail,
//   IconPhone,
//   IconTruck,
//   IconHomeSpark,
//   IconReceipt,
// } from "@tabler/icons-react";
// import { useFormContext, Controller } from "react-hook-form";
// import PhoneInput from "react-phone-number-input";
// import "react-phone-number-input/style.css";
// import usePostRequest from "../../hooks/usePostRequest";
// import useDebounce from "../../hooks/useDebounce";

// function PaymentAndShippingForm() {
//   const {
//     control,
//     watch,
//     getValues,
//     register,
//     setValue,
//     formState: { errors },
//   } = useFormContext();

//   const { debounceSearch } = useDebounce();
//   const suppressAutoUpdate = useRef(false);
//   const [searchDebounce, setSearchDebounce] = useState({
//     searchName: "",
//     searchEmail: "",
//   });
//   const [suggestion, setSuggestion] = useState([]);

//   const {
//     data: fetchdata,
//     isLoading,
//     postData: fetchUser,
//   } = usePostRequest(API_ENDPOINTS.GET_CUSTOMER_AUTOFILL);

//   const OrderType = watch("ordertype");

//   const prependCountryCodeIfMissing = (phoneNumber) => {
//     if (!phoneNumber) return phoneNumber;
//     const trimmed = phoneNumber.trim();
//     if (trimmed.startsWith("+")) {
//       return trimmed;
//     }
//     return "+1" + trimmed;
//   };

//   const handleSelect = (item) => {
//     suppressAutoUpdate.current = true;
//     setValue("selectedBySuggestion", true);
//     setValue("sameShipNameasKO", false);
//     setValue("sameBillNameasKO", false);

//     setValue(
//       "contractOfficerName",
//       `${item.first_name || ""} ${item.last_name || ""}`
//     );
//     setValue(
//       "contractOfficerEmail",
//       item?.primary_email ? item.primary_email.Address : ""
//     );
//     setValue(
//       "contractOfficerPhone",
//       prependCountryCodeIfMissing(item?.primary_phone?.FreeFormNumber || "")
//     );
//     setValue("contractOfficerAddress", item.address || "");

//     setValue("shippingCustomerName", item?.shipping_name || "");
//     setValue("shippingCustomerEmail", item?.shipping_email || "");
//     setValue(
//       "shippingCustomerPhone",
//       prependCountryCodeIfMissing(item?.shipping_phone || "")
//     );

//     if (item?.shipping_address) {
//       const address = item.shipping_address;
//       const formattedAddress = [
//         address.Line1,
//         address.Line2,
//         `${address.City || ""}${address.City ? "," : ""} ${
//           address.CountrySubDivisionCode || ""
//         } ${address.PostalCode || ""}`.trim(),
//         address.Country,
//       ]
//         .filter((line) => line && line.trim() !== "")
//         .join("\n");
//       setValue("shippingCustomerAddress", formattedAddress);
//     } else {
//       setValue("shippingCustomerAddress", "");
//     }

//     setValue("BillingCustomerName", item?.billing_name || "");
//     setValue("BillingCustomerEmail", item?.billing_email || "");
//     setValue(
//       "BillingCustomerPhone",
//       prependCountryCodeIfMissing(item?.billing_phone || "")
//     );

//     if (item?.billing_address) {
//       const address = item.billing_address;
//       const formattedAddress = [
//         address.Line1,
//         address.Line2,
//         `${address.City || ""}${address.City ? "," : ""} ${
//           address.CountrySubDivisionCode || ""
//         } ${address.PostalCode || ""}`.trim(),
//         address.Country,
//       ]
//         .filter((line) => line && line.trim() !== "")
//         .join("\n");
//       setValue("BillingCustomerAddress", formattedAddress);
//     } else {
//       setValue("BillingCustomerAddress", "");
//     }

//     setSuggestion(null);
//   };

//   const handleSearchByName = (e) => {
//     setSearchDebounce({ searchName: e.target.value });
//   };

//   const handleSearchByEmail = (e) => {
//     setSearchDebounce({ searchEmail: e.target.value });
//   };

//   const onSuccessData = (data) => {
//     setSuggestion(data);
//   };

//   const onErrorData = () => {
//     setSuggestion(null);
//   };

//   const handleBlur = () => {
//     setTimeout(() => {
//       setSuggestion(null);
//     }, 150);
//   };

//   useEffect(() => {
//     if (
//       searchDebounce?.searchEmail?.length > 0 ||
//       searchDebounce?.searchName?.length > 0
//     ) {
//       fetchUser(
//         {
//           email:
//             searchDebounce?.searchEmail?.length > 0
//               ? searchDebounce?.searchEmail
//               : undefined,
//           first_name:
//             searchDebounce?.searchName?.length > 0
//               ? searchDebounce?.searchName
//               : undefined,
//           module_type: "ORDER",
//         },
//         onSuccessData,
//         onErrorData
//       );
//     }
//   }, [debounceSearch, searchDebounce]);

//   const handleSameAsKO = (type, isChecked) => {
//     const koFields = {
//       name: getValues("contractOfficerName") || "",
//       email: getValues("contractOfficerEmail") || "",
//       phone: getValues("contractOfficerPhone") || "",
//       address: getValues("contractOfficerAddress") || "",
//     };

//     if (type === "shipping") {
//       if (isChecked) {
//         setValue("shippingCustomerName", koFields.name);
//         setValue("shippingCustomerEmail", koFields.email);
//         setValue("shippingCustomerPhone", koFields.phone);
//         setValue("shippingCustomerAddress", koFields.address);
//       } else {
//         setValue("shippingCustomerName", "");
//         setValue("shippingCustomerEmail", "");
//         setValue("shippingCustomerPhone", "");
//         setValue("shippingCustomerAddress", "");
//       }
//     } else if (type === "billing") {
//       if (isChecked) {
//         setValue("BillingCustomerName", koFields.name);
//         setValue("BillingCustomerEmail", koFields.email);
//         setValue("BillingCustomerPhone", koFields.phone);
//         setValue("BillingCustomerAddress", koFields.address);
//       } else {
//         setValue("BillingCustomerName", "");
//         setValue("BillingCustomerEmail", "");
//         setValue("BillingCustomerPhone", "");
//         setValue("BillingCustomerAddress", "");
//       }
//     }
//   };

//   const textareaRef = useRef(null);
//   const billingTextareaRef = useRef(null);

//   const address = watch("shippingCustomerAddress");
//   const BillingAddress = watch("BillingCustomerAddress");

//   const handleResize = (textarea) => {
//     if (textarea) {
//       textarea.style.height = "auto";
//       textarea.style.height = `${textarea.scrollHeight}px`;
//     }
//   };

//   useEffect(() => {
//     handleResize(textareaRef.current);
//   }, [address]);

//   useEffect(() => {
//     handleResize(billingTextareaRef.current);
//   }, [BillingAddress]);

//   useEffect(() => {
//     if (OrderType === "CRK" || OrderType === "M") {
//       setValue("initial_consolidation", true);
//     } else {
//       setValue("initial_consolidation", false);
//     }
//   }, [OrderType, setValue]);

//   return (
//     <>
//       <Row className="mb-3">
//         <Col md={3}>
//           <Form.Group className="mb-3">
//             <Form.Label>Estimated Delivery (Days)</Form.Label>
//             <InputGroup>
//               <Form.Control
//                 type="number"
//                 {...register("estimateddelivery")}
//                 defaultValue={30}
//               />
//             </InputGroup>
//             {errors.estimateddelivery && (
//               <span className="text-danger">
//                 {errors.estimateddelivery.message}
//               </span>
//             )}
//           </Form.Group>
//         </Col>

//         <Col md={3}>
//           <Form.Group className="mb-3">
//             <Form.Label>Payment Terms</Form.Label>
//             <InputGroup>
//               <Form.Select {...register("payment_terms")}>
//                 {TERMS.Term.map((item, index) => (
//                   <option key={index} value={item.Id}>
//                     {item.Name}
//                   </option>
//                 ))}
//               </Form.Select>
//             </InputGroup>
//             {errors.payment_terms && (
//               <span className="text-danger">
//                 {errors.payment_terms.message}
//               </span>
//             )}
//           </Form.Group>
//         </Col>

//         <Col md={3}>
//           <Form.Group className="mb-3">
//             <Form.Label>FOB</Form.Label>
//             <InputGroup>
//               <Form.Select {...register("shipping_terms")}>
//                 <option value={""}>Select a terms</option>
//                 <option value={"FOB Origin"}>FOB Origin</option>
//                 <option value={"FOB Destination"}>FOB Destination</option>
//               </Form.Select>
//             </InputGroup>
//             {errors.shipping_terms && (
//               <span className="text-danger">
//                 {errors.shipping_terms.message}
//               </span>
//             )}
//           </Form.Group>
//         </Col>
//         <Col md={3}>
//           <Form.Group className="mb-3">
//             <Form.Label>Shipping Method</Form.Label>
//             <InputGroup>
//               <Form.Select {...register("shipping_method")}>
//                 <option value={""}>Select a method</option>
//                 <option value={"UPS"}>UPS</option>
//                 <option value={"FedEx"}>FedEx</option>
//                 <option value={"Freight"}>Freight</option>
//                 <option value={"Other"}>Other</option>
//               </Form.Select>
//             </InputGroup>
//             {errors.shipping_method && (
//               <span className="text-danger">
//                 {errors.shipping_method.message}
//               </span>
//             )}
//           </Form.Group>
//         </Col>
//       </Row>

//       {["10"].includes(watch("payment_terms")) && (
//         <Col xs={12}>
//           <Form.Group className="mb-3">
//             <Form.Label>Payment Term Details</Form.Label>
//             <InputGroup>
//               <Form.Control
//                 type="text"
//                 placeholder={`Enter payment term details`}
//                 {...register("payment_term_detail")}
//               />
//             </InputGroup>
//             {errors.payment_term_detail && (
//               <span className="text-danger">
//                 {errors.payment_term_detail.message}
//               </span>
//             )}
//           </Form.Group>
//         </Col>
//       )}

//       {["Freight", "Other"].includes(watch("shipping_method")) && (
//         <Col xs={12}>
//           <Form.Group className="mb-3">
//             <Form.Label>
//               {watch("shipping_method") === "Freight"
//                 ? "Shipping Method Freight Details"
//                 : "Shipping Method Other Details"}
//             </Form.Label>
//             <InputGroup>
//               <Form.Control
//                 type="text"
//                 placeholder={`Enter ${watch("shipping_method")} details`}
//                 {...register("shipping_method_detail")}
//               />
//             </InputGroup>
//             {errors.shipping_method_detail && (
//               <span className="text-danger">
//                 {errors.shipping_method_detail.message}
//               </span>
//             )}
//           </Form.Group>
//         </Col>
//       )}

//       <Card className="mb-3">
//         <Card.Header className="card_header">
//           <IconFileDescription /> KO (Contracting Officer) Details
//         </Card.Header>
//         <Card.Body>
//           <Row>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Full name</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>
//                     <IconUser stroke={1} />
//                   </InputGroup.Text>
//                   <Form.Control
//                     {...register("contractOfficerName")}
//                     onChange={handleSearchByName}
//                     onBlur={handleBlur}
//                     placeholder="Enter Full Name"
//                   />
//                 </InputGroup>
//                 {suggestion?.data?.length > 0 &&
//                   (searchDebounce?.searchName?.length > 0 ||
//                     searchDebounce?.searchEmail?.length > 0) && (
//                     <div className="suggestions_box">
//                       <div className="table-responsive">
//                         <Table>
//                           <tbody>
//                             {suggestion?.data?.map((item, index) => (
//                               <tr
//                                 key={index}
//                                 onClick={() => handleSelect(item)}
//                                 style={{ cursor: "pointer" }}
//                               >
//                                 <td>{item?.display_name}</td>
//                                 <td>{`${item?.first_name || ""} ${
//                                   item?.last_name || ""
//                                 }`}</td>
//                                 <td>
//                                   {item?.primary_email
//                                     ? item.primary_email?.Address
//                                     : null}
//                                 </td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </Table>
//                       </div>
//                     </div>
//                   )}
//                 {errors.contractOfficerName && (
//                   <span className="text-danger">
//                     {errors.contractOfficerName.message}
//                   </span>
//                 )}
//               </Form.Group>
//             </Col>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Email</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>
//                     <IconMail stroke={1} />
//                   </InputGroup.Text>
//                   <Form.Control
//                     {...register("contractOfficerEmail")}
//                     onChange={handleSearchByEmail}
//                     onBlur={handleBlur}
//                     type="email"
//                     placeholder="Enter Email"
//                   />
//                 </InputGroup>
//                 {errors.contractOfficerEmail && (
//                   <span className="text-danger">
//                     {errors.contractOfficerEmail.message}
//                   </span>
//                 )}
//               </Form.Group>
//             </Col>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Phone</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>
//                     <IconPhone stroke={1} />
//                   </InputGroup.Text>
//                   <Controller
//                     name="contractOfficerPhone"
//                     control={control}
//                     rules={{
//                       required: "Phone number is required",
//                       validate: (value) =>
//                         (value && value.length > 0) || "Invalid phone number",
//                     }}
//                     render={({ field }) => (
//                       <PhoneInput
//                         className="form-control"
//                         {...field}
//                         defaultCountry="US"
//                         countryCallingCodeEditable={false}
//                         international
//                         placeholder="Enter phone number"
//                         onChange={field.onChange}
//                       />
//                     )}
//                   />
//                 </InputGroup>
//                 {errors.contractOfficerPhone && (
//                   <span className="text-danger">
//                     {errors.contractOfficerPhone.message}
//                   </span>
//                 )}
//               </Form.Group>
//             </Col>
//           </Row>
//           <Row>
//             <Col md={12}>
//               <Form.Group>
//                 <Form.Label>Address</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>
//                     <IconHomeSpark stroke={1} />
//                   </InputGroup.Text>
//                   <Form.Control
//                     as="textarea"
//                     {...register("contractOfficerAddress")}
//                     style={{
//                       height: "auto",
//                       minHeight: "80px",
//                       resize: "none",
//                     }}
//                     onInput={(e) => {
//                       e.target.style.height = "auto";
//                       e.target.style.height = `${e.target.scrollHeight}px`;
//                     }}
//                     placeholder="Enter Address"
//                   />
//                 </InputGroup>
//                 {errors.contractOfficerAddress && (
//                   <span className="text-danger">
//                     {errors.contractOfficerAddress.message}
//                   </span>
//                 )}
//               </Form.Group>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       <Card className="mb-3">
//         <Card.Header className="card_header">
//           <IconTruck /> Shipping Details
//         </Card.Header>
//         <Card.Body>
//           <Row>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Full name</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>
//                     <IconUser stroke={1} />
//                   </InputGroup.Text>
//                   <Form.Control
//                     {...register("shippingCustomerName")}
//                     type="text"
//                     placeholder="Enter Full Name"
//                   />
//                 </InputGroup>
//                 {errors.shippingCustomerName && (
//                   <span className="text-danger">
//                     {errors.shippingCustomerName.message}
//                   </span>
//                 )}
//               </Form.Group>
//             </Col>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Email</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>
//                     <IconMail stroke={1} />
//                   </InputGroup.Text>
//                   <Form.Control
//                     {...register("shippingCustomerEmail")}
//                     type="email"
//                     placeholder="Enter Email"
//                   />
//                 </InputGroup>
//                 {errors.shippingCustomerEmail && (
//                   <span className="text-danger">
//                     {errors.shippingCustomerEmail.message}
//                   </span>
//                 )}
//               </Form.Group>
//             </Col>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Phone</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>
//                     <IconPhone stroke={1} />
//                   </InputGroup.Text>
//                   <Controller
//                     name="shippingCustomerPhone"
//                     control={control}
//                     rules={{
//                       required: "Phone number is required",
//                       validate: (value) =>
//                         (value && value.length > 0) || "Invalid phone number",
//                     }}
//                     render={({ field }) => (
//                       <PhoneInput
//                         className="form-control"
//                         {...field}
//                         defaultCountry="US"
//                         countryCallingCodeEditable={false}
//                         international
//                         placeholder="Enter phone number"
//                         onChange={field.onChange}
//                       />
//                     )}
//                   />
//                 </InputGroup>
//                 {errors.shippingCustomerPhone && (
//                   <span className="text-danger">
//                     {errors.shippingCustomerPhone.message}
//                   </span>
//                 )}
//               </Form.Group>
//             </Col>
//           </Row>
//           <Row>
//             <Col md={12}>
//               <Form.Group>
//                 <Form.Label>Address</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>
//                     <IconHomeSpark stroke={1} />
//                   </InputGroup.Text>
//                   <Controller
//                     name="shippingCustomerAddress"
//                     control={control}
//                     render={({ field }) => (
//                       <Form.Control
//                         {...field}
//                         as="textarea"
//                         ref={(e) => {
//                           field.ref(e);
//                           textareaRef.current = e;
//                         }}
//                         style={{
//                           height: "auto",
//                           minHeight: "80px",
//                           resize: "none",
//                         }}
//                         onInput={(e) => {
//                           e.target.style.height = "auto";
//                           e.target.style.height = `${e.target.scrollHeight}px`;
//                         }}
//                         placeholder="Enter Address"
//                       />
//                     )}
//                   />
//                 </InputGroup>
//                 {errors.shippingCustomerAddress && (
//                   <span className="text-danger">
//                     {errors.shippingCustomerAddress.message}
//                   </span>
//                 )}

//                 <div className="d-flex gap-0 align-items-center flex-wrap mt-2">
//                   <Form.Text className="ko_button">
//                     <Form.Check
//                       className="ko_fill_link me-2"
//                       type="checkbox"
//                       id="sameShipNameasKO"
//                       label="Fill with KO’s information"
//                       {...register("sameShipNameasKO", {
//                         onChange: (e) =>
//                           handleSameAsKO("shipping", e.target.checked),
//                       })}
//                     />
//                   </Form.Text>
//                   <Form.Text className="d-none">
//                     <Form.Check
//                       className="ko_fill_link"
//                       type="checkbox"
//                       id="selectedBySuggestion"
//                       hidden
//                       {...register("selectedBySuggestion")}
//                     />
//                   </Form.Text>
//                 </div>
//               </Form.Group>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       <Card className="mb-4">
//         <Card.Header className="card_header">
//           <IconReceipt /> Billing Details
//         </Card.Header>
//         <Card.Body>
//           <Row>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Full Name</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>
//                     <IconUser stroke={1} />
//                   </InputGroup.Text>
//                   <Form.Control
//                     {...register("BillingCustomerName")}
//                     placeholder="Enter Full Name"
//                   />
//                 </InputGroup>
//                 {errors.BillingCustomerName && (
//                   <span className="text-danger">
//                     {errors.BillingCustomerName.message}
//                   </span>
//                 )}
//               </Form.Group>
//             </Col>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Email</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>
//                     <IconMail stroke={1} />
//                   </InputGroup.Text>
//                   <Form.Control
//                     {...register("BillingCustomerEmail")}
//                     type="email"
//                     placeholder="Enter Email"
//                   />
//                 </InputGroup>
//                 {errors.BillingCustomerEmail && (
//                   <span className="text-danger">
//                     {errors.BillingCustomerEmail.message}
//                   </span>
//                 )}
//               </Form.Group>
//             </Col>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Phone</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>
//                     <IconPhone stroke={1} />
//                   </InputGroup.Text>
//                   <Controller
//                     name="BillingCustomerPhone"
//                     control={control}
//                     rules={{
//                       required: "Phone number is required",
//                       validate: (value) =>
//                         (value && value.length > 0) || "Invalid phone number",
//                     }}
//                     render={({ field }) => (
//                       <PhoneInput
//                         className="form-control"
//                         {...field}
//                         defaultCountry="US"
//                         countryCallingCodeEditable={false}
//                         international
//                         placeholder="Enter phone number"
//                         onChange={field.onChange}
//                       />
//                     )}
//                   />
//                 </InputGroup>
//                 {errors.BillingCustomerPhone && (
//                   <span className="text-danger">
//                     {errors.BillingCustomerPhone.message}
//                   </span>
//                 )}
//               </Form.Group>
//             </Col>
//           </Row>
//           <Row>
//             <Col md={12}>
//               <Form.Group>
//                 <Form.Label>Address</Form.Label>
//                 <InputGroup>
//                   <InputGroup.Text>
//                     <IconHomeSpark stroke={1} />
//                   </InputGroup.Text>
//                   <Controller
//                     name="BillingCustomerAddress"
//                     control={control}
//                     render={({ field }) => (
//                       <Form.Control
//                         {...field}
//                         as="textarea"
//                         ref={(e) => {
//                           field.ref(e);
//                           billingTextareaRef.current = e;
//                         }}
//                         style={{
//                           height: "auto",
//                           minHeight: "80px",
//                           resize: "none",
//                         }}
//                         onInput={(e) => {
//                           e.target.style.height = "auto";
//                           e.target.style.height = `${e.target.scrollHeight}px`;
//                         }}
//                         placeholder="Enter Address"
//                       />
//                     )}
//                   />
//                 </InputGroup>
//                 {errors.BillingCustomerAddress && (
//                   <span className="text-danger">
//                     {errors.BillingCustomerAddress.message}
//                   </span>
//                 )}
//                 <Form.Text className="ko_button d-flex gap-2 mt-3">
//                   <Form.Check
//                     className="ko_fill_link"
//                     type="checkbox"
//                     id="sameBillNameasKO"
//                     label="Fill with KO’s information"
//                     {...register("sameBillNameasKO", {
//                       onChange: (e) =>
//                         handleSameAsKO("billing", e.target.checked),
//                     })}
//                   />
//                 </Form.Text>
//               </Form.Group>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>
//     </>
//   );
// }

// export default PaymentAndShippingForm;
